/*
 * @Author: shiguang
 * @Date: 2023-04-28 11:51:00
 * @LastEditors: yusha
 * @LastEditTime: 2024-07-30 13:40:52
 * @Description: interceptors
 */
import { message } from 'antd';
import gray from '@sniff/gray/dist/index.esm';
import { api, apiInstanceList } from '@/service';
import errorCode from '@/i18n/locales/errorCode.json';
import { getLang, strings } from '@/i18n/i18n';
import { serviceConfig } from './swaggerServiceConfig';

const graify = gray(serviceConfig.baseURL);

export interface User {
    loginInfo: {
        userId: string;
        username: string;
    };
    userInfo: {};
    auth: never[];
    token: string;
}

export const getToken = () => {
    const tokenStr = window.localStorage.getItem('production_route/token');
    if (!tokenStr) return;
    try {
        const token = JSON.parse(tokenStr).val as User;
        return token;
    } catch (e) {
        return undefined;
    }
};

export const getShopId = () => {
    const shopStr = window.localStorage.getItem('production_route/curShop');
    if (!shopStr) return;
    try {
        const token = JSON.parse(shopStr).val as User;
        return token;
    } catch (e) {
        return undefined;
    }
};

/**
 * admin 端
 */
export const getUserInLocal = () => {
    const usrStr = window.localStorage.getItem('user');
    if (!usrStr) return;
    try {
        const user = JSON.parse(usrStr).user as User;
        return user;
    } catch (e) {
        return undefined;
    }
};

apiInstanceList.forEach((item) => {
    // 请求拦截
    item.instance.instance.interceptors.request.use(async function (config) {
        config.headers = config.headers ?? {};
        const isPost = ['POST', 'post'].includes(config.method!);
        const token = getToken();
        const shopId = getShopId();
        if (token) {
            config.headers['X-Authtoken'] = token;
        }
        if (shopId) {
            // config.headers['X-Authshopid'] = shopId;
        }
        let X_GRAY_TAG = process.env.REACT_APP_X_GRAY_TAG;
        if (process.env.NODE_ENV === 'production') {
            const env = window.location.host.split('-s.theckb.com');
            if (!env[0] || env[0] === 'pre') {
                X_GRAY_TAG = undefined;
            } else {
                X_GRAY_TAG = env[0];
            }
        }
        if (X_GRAY_TAG) {
            config.headers['X-GRAY-TAG'] = X_GRAY_TAG;
        }
        config.headers['X-Platform'] = 'PC';
        // 应用名称
        config.headers['X-Appname'] = 'ckb-smc-pc';
        if (isPost) {
            if (!config.data && config.params) {
                config.data = config.params;
            }
            config.params = {};
            config.headers['Content-Type'] = 'application/json';
        }
        await graify(config);
        return config;
    });

    // 返回拦截
    item.instance.instance.interceptors.response.use(
        function (response) {
            if (response.data?.code === '0' && response.data.success === true)
                return response;
            // if (response.data.code === 401) {
            //     if (!window.location.pathname.endsWith('/login')) {
            //         // 跳转登陆
            //         window.location.pathname = `/user/login`;
            //     }
            //     return Promise.reject(response.data.msg);
            // }
            // message.error(String(response.data.msg));
            const lang = getLang();
            /** 翻译后的错误信息, 若是不存在，则展示中文 */
            const errMessaage =
                errorCode[lang][response.data?.code] ??
                errorCode['zh_CN'][response.data?.code] ??
                errorCode['noMatch'];
            return Promise.reject(errMessaage);
        },
        function (error) {
            return Promise.reject(error);
        }
    );
});

export const request = api;
